import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["number"]
  static values = { duration: { type: Number, default: 1500 } }

  connect() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.animateAll()
          this.observer.disconnect()
        }
      })
    }, { threshold: 0.15 })

    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  animateAll() {
    this.numberTargets.forEach(el => {
      const end = parseInt(el.dataset.countUpEnd, 10)
      const suffix = el.dataset.countUpSuffix || ""
      this.animateNumber(el, end, suffix)
    })
  }

  animateNumber(el, end, suffix) {
    const duration = this.durationValue
    const start = performance.now()

    const step = (now) => {
      const elapsed = now - start
      const progress = Math.min(elapsed / duration, 1)
      const eased = 1 - Math.pow(1 - progress, 3)
      const current = Math.round(eased * end)

      el.textContent = current + suffix

      if (progress < 1) {
        requestAnimationFrame(step)
      }
    }

    requestAnimationFrame(step)
  }
}
